import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

export const getMotivosOuvidoriaColumns = ({ onEdit, onDelete } = {}) => [
  {
    id: 'nomeMotivo',
    header: 'Nome do Motivo',
    accessorKey: 'nomeMotivo',
    size: 220,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={60} />,
  },
  {
    id: 'descricao',
    header: 'Descrição',
    accessorKey: 'descricao',
    size: 320,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={120} />,
  },
  {
    id: 'dataCriacao',
    header: 'Data de Criação',
    accessorKey: 'dataCriacaoFormatada',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() || '-'}</span>,
  },
  ...(onEdit || onDelete
    ? [
        {
          id: 'actions',
          header: 'Ações',
          size: 160,
          enableSorting: false,
          cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '6px' }}>
              {onEdit && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-primary"
                  onClick={event => {
                    event.stopPropagation();
                    onEdit(row.original.id);
                  }}
                >
                  Editar
                </ButtonWithLoading>
              )}
              {onDelete && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-danger"
                  onClick={event => {
                    event.stopPropagation();
                    onDelete(row.original.id);
                  }}
                >
                  Excluir
                </ButtonWithLoading>
              )}
            </div>
          ),
        },
      ]
    : []),
];
